import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Problems from './components/Problems';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import Footer from './components/Footer';
import { WhatsappSupportButton } from './components/WhatsappSupportButton';
import Lgpd from './pages/lgpd';
import TermosDeUso from './pages/termos-de-uso';
import TermosDePrivacidade from './pages/termos-de-privacidade';
import { useViewContentSections } from './hooks/useViewContentSections';

const Home: React.FC = () => {
  const location = useLocation();
  useViewContentSections();

  useEffect(() => {
    // Se há um hash na URL, rolar para o elemento correspondente
    if (location.hash) {
      const elementId = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100); // Pequeno delay para garantir que a página carregou
    }
  }, [location]);

  return (
    <>
      <Header />
      <Hero />
      <Problems />
      <Features />
      <Testimonials />
      <Pricing />
      <Footer />
    </>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lgpd" element={<Lgpd />} />
        <Route path="/termos-de-uso" element={<TermosDeUso />} />
        <Route path="/termos-de-privacidade" element={<TermosDePrivacidade />} />
      </Routes>
      <WhatsappSupportButton />
    </BrowserRouter>
  );
};

export default App; 
